import { useCallback, useState } from 'react';
import { Select, Typography, Flex, Spin, Popover } from 'antd';
import { debounce } from 'lodash';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = Select;

const CustomerSearch = ({
    value,
    onChange,
    size = 'large',
    placeholder = 'Search Assign User',
    showUnassigned = false,
    disabled = false,
    multiple = false,
    data,
}) => {
    const { customers } = useSelector((state) => state.customersSlice);
    const [loading, setLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(true);

    const options = data || customers || [];

    const handleUserSearch = useCallback(
        debounce(async (searchValue) => {
            setIsSearched(!!searchValue);
            setLoading(true);
            // await getUsers({ searchText: searchValue, loading: false });
            setLoading(false);
        }, 300),
        []
    );

    return (
        <Select
            mode={multiple ? 'multiple' : undefined}
            placeholder={placeholder}
            optionLabelProp="label"
            style={{ width: '100%' }}
            size={size}
            showSearch
            allowClear
            virtual
            disabled={disabled}
            value={value}
            onChange={(val) => {
                onChange?.(val);
            }}
            filterOption={(input, option) =>
                String(option['data-title'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase()) ||
                String(option['data-code'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            onSearch={handleUserSearch}
            maxTagCount="responsive"
            maxTagPlaceholder={(omittedValues) => (
                <Popover
                    content={omittedValues.map((v) => (
                        <div key={v.value || v.key}>
                            <Typography.Text>{v.label}</Typography.Text>
                        </div>
                    ))}
                    title="Other Customers"
                    trigger="hover"
                    autoAdjustOverflow
                >
                    <span>+{omittedValues.length}</span>
                </Popover>
            )}
            notFoundContent={
                loading ? (
                    <Flex justify="center" align="center" gap={10}>
                        <Typography.Text type="secondary">Loading...</Typography.Text>
                        <Spin indicator={<LoadingOutlined spin />} size="small" />
                    </Flex>
                ) : isSearched ? (
                    <Flex justify="center" align="center" gap={10}>
                        <Typography.Text type="secondary">No Results</Typography.Text>
                    </Flex>
                ) : null
            }
        >
            {showUnassigned && (
                <Option key="unassigned" value="unassigned" label="Unassigned">
                    <Typography.Text strong type="secondary">
                        Unassigned
                    </Typography.Text>
                </Option>
            )}

            {isSearched &&
                options?.map((customer, idx) => (
                    <Option
                        key={idx}
                        value={customer?.customer_netsuite_id}
                        label={`[${customer?.code}] ${customer?.title}`}
                        data-code={customer?.code}
                        data-title={customer?.title}
                    >
                        <Typography.Text>
                            [{`${customer?.code}`}] {customer?.title}
                        </Typography.Text>
                    </Option>
                ))}
        </Select>
    );
};

export default CustomerSearch;
